import React from 'react';

const SixthSection = () => {
    return (
        <div data-aos="fade-down-left" className="mt-10 shadow-md shadow-slate-400 p-5 ">
        <h1 className="text-2xl text-primary font-semibold underline text-left">
        We have a coordination test for humanity:{" "}
        </h1>
        <p className="mt-2 text-lg font-medium text-slate-600 text-left">
        If we have every individual with a self-interest approach we go into a terrible situation. The more we convert to love for others the better chance we have to pass the test. 
        </p>
  
  
        <p className="mt-10 text-xl border-l-4 border-primary font-medium text-slate-600 text-left pl-5 font-sans hover:font-serif">
        “If only we could make love what people optimize for over wealth. We can help society at large realize that is the true way to win the game of life” -<a  className="underline link-primary" href="https://jackjay.io/">Jack Jay</a> 
        </p> <br />

        <p className="mt-2  text-lg font-medium text-slate-600 text-left">
        It wasn't until our culture defined cigarettes as bad that we quit them. They are just as addicting. They become negative status symbols. Hopefully showing the power status has on human behavior. If you thought sex/mating runs the world just wait till you realize that status is above even that.  <br />
        <br />

        If we can change whats cool, then love can rule. <br /> <br />
 
If you are moved, then let’s move mountains. <br /> <br />
Schedule a call <a className='underline link-primary' href="https://www.calendar.com/not-found/">HERE</a>
        </p>
      </div>
    );
};

export default SixthSection;